import React from 'react';
import ReactDOM from 'react-dom';
import Root from 'views/Root';
// import VConsole from 'vconsole';

// var vConsole = new VConsole();
// console.log('Hello world');

ReactDOM.render(<Root />, document.getElementById('root'));
